module.exports = __webpack_public_path__ + "img/2.d39b9cf2.jpg";